import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {grey} from './color';

export const TextSkeleton = styled.div`
    margin-top: 4px;
    margin-top: 2px;
    height: 16px;
    width: ${({width}) => width};
    background-color: ${(props) => props.color};
`;
TextSkeleton.displayName = 'TextSkeleton';

TextSkeleton.propTypes = {
    color: PropTypes.string,
    width: PropTypes.string
};

TextSkeleton.defaultProps = {
    color: grey.grey800,
    width: '95px'
};

export const TextSkeletonLarge = styled(TextSkeleton)`
    margin-top: 4px;
    margin-bottom: 2px;
    height: 18px;
`;

TextSkeletonLarge.displayName = 'TextSkeletonLarge';

TextSkeletonLarge.propTypes = {
    color: PropTypes.string,
    width: PropTypes.string
};

TextSkeletonLarge.defaultProps = {
    color: grey.grey800,
    width: '95px'
};

export function PSkeleton() {
    return (
        <div>
            <TextSkeleton width='60%'/>
            <Margin/>
            <TextSkeleton width='60%'/>
            <Margin/>
            <TextSkeleton width='40%'/>
        </div>
    );
}

const Margin = styled.div`
  margin-bottom: 8px;
`;
